import { render, staticRenderFns } from "./insert.vue?vue&type=template&id=5407d0b2&lang=pug&"
import script from "./insert.vue?vue&type=script&lang=js&"
export * from "./insert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports